import React from 'react';
import { identity } from 'ramda';

export const ListContext = React.createContext({
    dispatch: identity
});

export const DetailsContext = React.createContext({
    dispatch: identity
});
